export enum MttColumnWidth {
    GeneralInformation = 450,
    WK = 60,
    ProjectedGrade = 78,
    StudentName = 200,
    CourseAndTeacher = 250,
    MttStatus = 100,
}